<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?e39565f0607784f1cbf7fd07ee47adcc'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()
export default {
  name: 'App'
}
</script>

<style>
	@import url('/css/color.css');
	@import url('/css/default.css');
	@import url('/css/flex.css');
	@import url('/css/fontSize.css');
	@import url('/css/paddingAndMargin.css');

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	* {
		padding: 0;
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue